.content {
  display: flex;
  align-items: center;
  gap: var(--spacing);
}

.icon {
  width: 44px;
}
